import { empty } from './empty'
import {
  dashboard,
  cardSwipe,
  coin,
  documentTick,
  frame,
  handSave,
  notification,
  order,
  payment,
  securityTick,
  userThree,
  userTwo,
  logout,
  isApproved,
  hamburger,
  eye,
  eyeOff,
  user,
  deleteIcon,
  editIcon,
  iCircle,
  stacks,
  terms,
  userFill,
  questionCircle,
  plus,
  search,
  down,
  camera,
  upload,
  manageProfile,
  passwordIcon,
  bookIcon,
  historyIcon,
  aboutIcon,
  privacyIcon,
  termsIcon,
  supportIcon,
  deactivateIcon,
  logoutIcon,
  phoneIcon,
  locationIcon,
  galleryIcon,
  leftArrow,
  book,
  deliveryIcon,
  seo,
  userExclamation,
  phoneHome,
  historyHome,
  accountHome,
  plusHome,
  backNavigation,
  successIcon,
  supportLocationIcon,
  chatIcon,
  callIcon,
  emailIcon,
  mailIcon,
  rocketIcon,
  alreadyBorrowed,
  noBooksIcon,
  notFoundSearch,
  noBooksLent,
  noBooksListing,
  khalti,
  noBook,
  delivery,
  deactivate,
  whatsApp,
  call,
  error,
  message,
  notificationBook,
  transaction,
  emptyNotification,
  moneyBag,
  finger,
  moreBook,
} from './svg'
export default {
  empty,
  dashboard,
  cardSwipe,
  coin,
  documentTick,
  frame,
  handSave,
  notification,
  order,
  payment,
  securityTick,
  userThree,
  userTwo,
  logout,
  isApproved,
  hamburger,
  eye,
  eyeOff,
  user,
  deleteIcon,
  editIcon,
  iCircle,
  stacks,
  terms,
  userFill,
  questionCircle,
  plus,
  search,
  down,
  upload,
  camera,
  manageProfile,
  passwordIcon,
  bookIcon,
  historyIcon,
  aboutIcon,
  privacyIcon,
  termsIcon,
  supportIcon,
  deactivateIcon,
  logoutIcon,
  phoneIcon,
  locationIcon,
  galleryIcon,
  leftArrow,
  book,
  deliveryIcon,
  seo,
  userExclamation,
  phoneHome,
  historyHome,
  accountHome,
  plusHome,
  backNavigation,
  successIcon,
  supportLocationIcon,
  chatIcon,
  callIcon,
  emailIcon,
  mailIcon,
  rocketIcon,
  alreadyBorrowed,
  noBooksIcon,
  notFoundSearch,
  noBooksLent,
  noBooksListing,
  khalti,
  noBook,
  delivery,
  deactivate,
  whatsApp,
  call,
  error,
  message,
  notificationBook,
  transaction,
  emptyNotification,
  moneyBag,
  finger,
  moreBook,
}
